import React, { Component } from 'react'
import './stylesheets/changepassword.css'
import HeaderBack from '../../../components/backoffice/headerback/HeaderBack'
import {getBackSiteid,getBackMappingArea,getBackMappingEquipments,getBackMappingComponent,getBackSelectionType,postSubmitScheduled,getBackJobsData,getBackJobReleased,getBackEnggList,postSubmitReleased,postSubmitSaved} from '../../../modules/serverCall'
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from 'react-bootstrap-table-next';
import Moment from 'moment';
import Multiselect from 'multiselect-react-dropdown';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import DatePicker from 'react-datepicker';
import { BsCheckCircle, BsHourglass } from "react-icons/bs";
import { MdSchedule } from "react-icons/md";
import { RxRocket, RxCrossCircled } from "react-icons/rx";
import { RiSave3Line } from "react-icons/ri";
import { FaRegThumbsUp,FaPlusCircle,FaTrashAlt,FaPauseCircle } from "react-icons/fa";
import {Button, Dropdown, Offcanvas, FloatingLabel, Form,Table,Tab,Tabs } from 'react-bootstrap';
import overlayFactory from 'react-bootstrap-table2-overlay';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import Select from 'react-select';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
 
export default class Changepassword extends Component {
  constructor(props) {
    super(props);
    var startDateData = Moment(new Date());
    var endDateData = Moment(startDateData).endOf('month');
    var lasttdateData = new Date(endDateData);
    this.state = {
      startDate:new Date(),
      endDate:new Date(),
      lasttdate:lasttdateData,
      showData: false,
      scroll: false,
      backdrop: false,
      placement: 'end',
      jobdetails:[],
      IsActiveOther:'Vendor',
      expanded: [0, 1],
      currnetmonthdata:new Date(),
      customer:'Job Id',
      statusId: 'Month',
      selectedStatus:"Month",
      siteId: 0,
      selectedStatus:"Status",
      selectedEmployee:"Employee",
      selectedBranch:"Branch",
      selectedSite:"Dept/Site",
      selectedName:"Name",
      selectedEmailid:"Email id",
      listSiteId:'',
      selectedArea:"ZN /Div",
      listAreaId:'',
      selectedProd:"prod/Serv",
      listProdId:'',
      submitbtn:false,
      loading:false,
      showbtn:false,
      loadingData:'No data found',
      engg:[],
    }
  }

  componentDidMount () {
    window.scrollTo(0, 0);
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    // const userId =  readData.userdata.user_id;
    const userId =  1;
    var editBtn = true;
    const permissionsdata =  localStorage.getItem('permissions');
    const permissionsreadData = JSON.parse(permissionsdata);
    // const filteredData = permissionsreadData.filter(obj => {
    //   return obj.PermissionCode === 'APPROVE_JOB' || obj.PermissionCode === 'SCHEDULE_JOB';
    // });
    // if(filteredData.length > 0){
    //   editBtn = true;
    // }
    var sendData = {
        userid:userId,
    }
    const fetchsiteid = async () => {
      // const responsesites = await getBackSiteid(sendData);
      // const datarespsites  = await responsesites;
      
      var sendDataJob={
        selectionType:120,
      }

      var JobTypeIdArr = [];

      var sendDataStatus={
        selectionType:40,
      }
      var StatusIdArr = [];
    
      var siteIdArr = [];
      // for (var i = 0; i < datarespsites.length; i++) {
      //   var siteId={};
      //   siteId.key = datarespsites[i].SiteID;
      //   siteId.value = datarespsites[i].SiteName;
      //   siteIdArr.push(siteId);
      // }

      this.setState({
        listSiteId:siteIdArr,
        // selectedSite:siteIdArr[0].value,
        // siteId:siteIdArr[0].key,
        JobTypeIdArr:JobTypeIdArr,
        JobStatus:StatusIdArr,
        editBtn:editBtn
      });
    };
    fetchsiteid();
  }

  handleInputFetch = event => {
    var AllowanceArr = [];
    var submitbtn = true;
    var loadingData ='No data found'
    this.setState({
      loading:true,
      loadingData:'Loading',
    });
    var AllowanceArr = [];
    var dateData = this.state.currnetmonthdata;
    var monthData = dateData.getMonth();
    var year = (dateData).getFullYear();
    const siteId =  this.state.siteId;
    const areaId =  this.state.areaId;
    var sendData = {
        month:monthData + 1,
        year:year,
        site_id:siteId,
        area_id:areaId
    }
    const fetchAllowancedetails = async () => {
      const responseAllowance = await getBackJobsData(sendData);
      const datarespAllowance  = await responseAllowance;
     
      if(datarespAllowance.length > 0){
        AllowanceArr = datarespAllowance;
      }else{
          loadingData = "No data found";
      }
      

      this.setState({
        jobdetails:AllowanceArr,
        loading:false,
        loadingData:loadingData
      });
    };
    fetchAllowancedetails();
  }

handleDropdown = (key, event)=>{
    this.setState({ selectedStatus:event.target.innerHTML,statusId:key,jobdetails:[],submitbtn:false,showData:false});
}

handleDropdownSite = (key, event)=>{
  var sendDataArea = {
    siteId:key,
  }
  var EquipmentListArr = [];
  const fetcAreadetails = async () => {
  const responsearea = await getBackMappingArea(sendDataArea);
  const dataresparea  = await responsearea;

  var areaIdArr = [];
  
  for (var i = 0; i < dataresparea.length; i++) {
    var areaId={};
    areaId.key = dataresparea[i].AreaID;
    areaId.value = dataresparea[i].AreaName;
    areaIdArr.push(areaId);
  }
    var areaIDValue = 'Select Area';
    var areaIdArrKey = 0;
    if(areaIdArr.length > 0){
      areaIDValue = areaIdArr[0].value;
      areaIdArrKey = areaIdArr[0].key;
    }
    
    if(areaIdArrKey !== ''){
      var submitData = {
        equipmentId:areaIdArrKey,
      }
      const responseMaster = await getBackMappingEquipments(submitData);
      const datarespMaster  = await responseMaster;
      for (var i = 0; i < datarespMaster.length; i++) {
        if(datarespMaster[i].EqptIsActive === true){
          var EquipmentList={};
          EquipmentList.value = datarespMaster[i].AreaEquipmentID;
          EquipmentList.label = datarespMaster[i].AreaEquipmentName;
          EquipmentList.equipmentName = datarespMaster[i].EquipmentName;
          EquipmentList.equipmentID = datarespMaster[i].EquipmentID;
          EquipmentListArr.push(EquipmentList);
        }
      }
    }
    this.setState({
      listAreaId:areaIdArr,
      selectedArea:areaIDValue,
      areaId:areaIdArrKey,
    });
  };
  fetcAreadetails();
    this.setState({ selectedSite:event.target.innerHTML,siteId:key,jobdetails:[],showData:false,show:false,optionsEquipment:EquipmentListArr});
}

handleDropdownArea = (key, event)=>{
  var submitData = {
    equipmentId:key,
  }
  var EquipmentListArr=[];
  const fetchEquipmentdetails = async () => {
    const responseMaster = await getBackMappingEquipments(submitData);
    const datarespMaster  = await responseMaster;
    
    for (var i = 0; i < datarespMaster.length; i++) {
      if(datarespMaster[i].EqptIsActive === true){
        var EquipmentList={};
        EquipmentList.value = datarespMaster[i].AreaEquipmentID;
        EquipmentList.label = datarespMaster[i].AreaEquipmentName;
        EquipmentList.equipmentName = datarespMaster[i].EquipmentName;
        EquipmentList.equipmentID = datarespMaster[i].EquipmentID;
        EquipmentListArr.push(EquipmentList);
      }
    }
  };
  fetchEquipmentdetails();
  this.setState({ selectedArea:event.target.innerHTML,areaId:key,jobdetails:[],showData:false,showbtn:false , optionsEquipment:EquipmentListArr});
}

handleChangeStart = (selectedDate) => {
  const MySwal = withReactContent(Swal);
    this.setState({
      StartDateTime: selectedDate,
    });
}

handleChangeStartReleased = (selectedDate) => {
  const MySwal = withReactContent(Swal);
    this.setState({
      JobSchStartDateReleased: selectedDate,
      JobSchEndDateReleased:'',
    });
}


handleOnChange=(selected) => {
  this.setState({
       engg: selected
   });
}

handleFormValidation = event => {
  let isError = this.state.isError;
  var validationcon = [];
  if(event.PTWNumberReleased === ''){
    isError['PTWNumberReleased'] = 'PTW is mandatory to release the job';
    this.setState({isError});
    validationcon.push(1);
  }else{
    isError['PTWNumberReleased'] = '';
    this.setState({isError});
  }

  if(event.WorkReqbyReleased === ''){
    isError['WorkReqbyReleased'] = 'Work Req by is mandatory to release the job';
    this.setState({isError});
    validationcon.push(1);
  }else{
    isError['WorkReqbyReleased'] = '';
    this.setState({isError});
  }

  if(event.WorkForceReleased === ''){
    isError['WorkForceReleased'] = 'Workforce is mandatory to release the job';
    this.setState({isError});
    validationcon.push(1);
  }else{
    isError['WorkForceReleased'] = '';
    this.setState({isError});
  }
  if(event.engg.length <= 0){
    isError['engg'] = 'Please select the Engineers to release the job';
    this.setState({isError});
    validationcon.push(1);
  }else{
    isError['engg'] = '';
    this.setState({isError});
  }
  // var validation = Moment(event.JobSchEndDateReleased).isSameOrAfter(event.JobSchStartDateReleased);

  // if(event.validation !== true){
  //   isError['timeVali'] = 'Job End date must be either on the same date as the job start date or greater than that';
  //   this.setState({isError});
  //   validationcon.push(1);
  // }else{
  //   isError['timeVali'] = '';
  //   this.setState({isError});
  // }

  return validationcon;
}

handleSubmitReleased = event => {
  event.preventDefault();
  const MySwal = withReactContent(Swal);
  var resp = this.handleFormValidation(this.state);
  const accesstokendata =  localStorage.getItem('access_token');
  const readData = JSON.parse(accesstokendata);
  const userId =  readData.userdata.sub;
  var statusJob = this.state.JobStatus;
  const filtered = statusJob.filter(obj => {
    return obj.value === 'Released';
  });
  var status = 0;
  if(filtered.length > 0){
    status = filtered[0].key;
  }
  
  // const currentMonthdata = this.state.currnetmonthdata;
  var validation = Moment(event.JobSchEndDateReleased).isSameOrAfter(event.JobSchStartDateReleased);
  if(validation === true){
    var submitData = {
      JobID: this.state.JobIDReleased,
      JobSchStartDate: Moment(this.state.JobSchStartDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      JobSchEndDate: Moment(this.state.JobSchEndDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      JobActualStartDate: Moment(this.state.JobActualStartDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      JobActualEndDate:Moment(this.state.JobActualEndDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      WorkReqby: this.state.WorkReqbyReleased,
      PTWNumber:this.state.PTWNumberReleased,
      EnggClosureComments:this.state.EnggClosureCommentsReleased,
      EnggClosureDate: this.state.EnggClosureDateReleased,
      HODClosureComments: this.state.HODClosureCommentsReleased,
      HODClosureDate: this.state.HODClosureDateReleased,
      DelayReason:this.state.DelayReasonReleased,
      JobEstTime:parseFloat(this.state.JobEstTimeReleased),
      WorkForce: this.state.WorkForceReleased === '' ? 0 : this.state.WorkForceReleased,
      WorkInstructions:this.state.WorkInstructionsReleased,
      ModifiedBy: userId
    }
    var submitDataReleased = {
      JobID: this.state.JobIDReleased,
      JobSchStartDate: Moment(this.state.JobSchStartDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      JobSchEndDate: Moment(this.state.JobSchEndDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      JobActualStartDate: Moment(this.state.JobActualStartDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      JobActualEndDate:Moment(this.state.JobActualEndDateReleased).format('YYYY-MM-DD HH:mm:ss'),
      WorkReqby: this.state.WorkReqbyReleased,
      PTWNumber:this.state.PTWNumberReleased,
      EnggClosureComments:this.state.EnggClosureCommentsReleased,
      EnggClosureDate: this.state.EnggClosureDateReleased,
      HODClosureComments: this.state.HODClosureCommentsReleased,
      HODClosureDate: this.state.HODClosureDateReleased,
      DelayReason:this.state.DelayReasonReleased,
      JobEstTime: parseFloat(this.state.JobEstTimeReleased),
      WorkForce: this.state.WorkForceReleased,
      WorkInstructions:this.state.WorkInstructionsReleased,
      JobStatus: status,
      ModifiedBy: userId
    }
    const addReleased = async () => {
      if(this.state.submitvalue ==='2'){
        const responseScheduled = await postSubmitReleased(submitDataReleased);
        if(responseScheduled === 200){
          this.handleInputFetch();
          this.setState({ showData: false});
        }
      }else{
        const responseScheduled = await postSubmitSaved(submitData);
        if(responseScheduled === 200){
          this.handleInputFetch();
          this.setState({ showData: false});
        }
      }
      
     
    };
    if(this.state.submitvalue ==='2' && resp.length <= 0){
        var msg = 'Are you sure you want to update?.';
        Swal.fire({
          title: 'Are you sure?',
          text: msg,
          icon: 'warning',
          showCancelButton: true,
          allowOutsideClick:false,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
            addReleased();
          }
      })
    }else if(this.state.submitvalue ==='1'){
      this.setState({
        isError:{
          PTWNumberReleased:'',
          WorkReqbyReleased:'',
          WorkForceReleased:'',
          engg:'',
          timeVali:'',
        }
      });
      var msg = 'Are you sure you want to update?.';
      Swal.fire({
        title: 'Are you sure?',
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        allowOutsideClick:false,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          addReleased();
        }
      })
    }
  }else{
    let isError = this.state.isError;
    isError['timeVali'] = 'Job End date must be either on the same date as the job start date or greater than that';
    this.setState({isError});
  }
  
}


handleClose = event => {

  this.setState({ 
    showData: false,
    EquipmentScheduler:'',
    EquipmentSchedulerName:'',
    equipmentId:'',
    JobTypeScheduler:'',
    StartDateTime:'',
    EndDateTime:'',
    WorkReqby:'',
    WorkForce:'',
    PTWNumber:'',
    JobEstTime:'',
    WorkInstructions:'',
    ComponentAddScheduledData:[],
  });
} 

handleDataChangeOther = event => {
  event.preventDefault();
  this.setState({
    [event.target.name]: event.target.value,
  });
}

handleShow = (event,row) => {
  var showAdd = false;
  var StatusData ="";
  var dateData = this.state.currnetmonthdata;
  var monthData = dateData.getMonth();
  var year = (dateData).getFullYear();
  const siteId =  this.state.siteId;
  const statusId =  this.state.statusId;
  
  this.setState({ showData: true,showAdd:showAdd,openStatus:event});
}


  render() {
    const addUserLogo = require('../../../assets/images/plus.png');
    var currnetMonthData = this.state.currnetmonthdata;
    var listAreaId =[];
    var listProdId = [];
    var listStatus = [];
    var listCustomerId= [];
    var currnetMonth = '';
    var columns='';
    if(currnetMonthData === ''){
      currnetMonth = new Date();
    }else{
      currnetMonth = currnetMonthData;
    }
    var listSiteId = this.state.listSiteId;
      columns = [{
        dataField:'Empl',
        text: 'Empl #',
        filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        sort: true,
        classes: 'cursorPoint removePadding',
        headerClasses: 'sch-headerName cursorPoint',
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.handleShow('Acceptance');
          },
        },
      },{
        dataField:'Name',
        text: 'Name',
        filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        sort: true,
        classes: 'cursorPoint removePadding',
        headerClasses: 'sch-headerName cursorPoint',
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) => {
            this.handleShow('Details');
          },
        },
      },{
        dataField:'Branch',
        text: "Branch / Dept / Site etc",
        // filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        // sort: true,
        classes: 'cursorPoint removePadding',
        headerClasses: 'sch-headerName cursorPoint',
      }
    ];
    var jobsdata = [];
    var optionsArray = this.state.enggData;
    var JobComponentsReleased = this.state.JobComponentsReleased;
    const customStyles = {
      menu: (provided, state) => ({
        ...provided,
        border:'none',
        borderStyle:'none',
        // minHeight:0,
        // maxHeight:310,
        // overflowY: 'scroll',
        // height:200,
        fontSize:11,
        opacity: 1,
        zIndex: 11,
        width: 290,
        top:18,
      }),
      menuList: (provided, state) => ({
        ...provided,
        height:200,
      }),
      control: () => ({
        alignItems: 'center',
        borderColor: 'none',
        borderRadius: 0,
        borderStyle: 'none',
        borderWidth: 0,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        // outline: 0 !important;
        position: 'absolute',
        transition: 'all 100ms',
        boxSizing: 'border-box',
        fontSize:11,
        width: 290,
      }),
      indicatorSeparator: () => ({
        margin:0,
        padding:0,
        display: 'none',
      }),
      indicatorsContainer: () => ({
        margin:0,
        padding:0,
        display: 'none',
        
      }),
      singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const cursor = 'pointer';
    
        return { ...provided, opacity, cursor };
      }
    }
    
    return (
      <div>
      <HeaderBack/>
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-all">
            <div className="submiteditbtnsche">
                <img src={addUserLogo}
                                alt="logo" className="logo-add-user cursorPoint" title='Add'  onClick={() => {this.handleShow('Add')}}/>
              </div>
          </div>
        </div>
        <div className="table-container-all">
        
        <BootstrapTable
            classes="tabledata-all"
            keyField="TechnicianID"
            id="tabledata"
            data={ jobsdata }
            columns={ columns }
            // overlay={overlayFactory({
            //   spinner: true,
            // })}
            filter={ filterFactory({className: 'custom_filter_class'}) }
            loading={this.state.loading}
            noDataIndication={this.state.loadingData}
          />
        </div>

        <Offcanvas className="useroff-sch" show={this.state.showData} scroll={this.state.scroll} name={this.state.name} backdrop={this.state.backdrop} placement={this.state.placement} onHide={this.handleClose}>
            <Offcanvas.Header className="popup_header" closeButton>
              <Offcanvas.Title className="header_title">
                  <span className="title_contant">
                   {this.state.openStatus}
                  </span>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="container">
                  <div className="rowUser justify-content-center">
                    <div className="col-md-12">
                      {this.state.openStatus === 'Add' ?
                      <form className="pr-5 mb-5 formUser" method="POST" onSubmit={this.handleSubmit}>
                          <div className="row">
                            <div className="col-md-6 form-group input-user">
                            <FloatingLabel controlId="floatingSelect" className="lableWidth" label="Employee # *">
                                <Form.Select aria-label="Employee #" name="ComponentTypeID" onChange={this.handleDataChangeOther} required={true} className="edit_job form__field_select selectAsealign" value={this.state.ComponentTypeID}>
                                  <option value=''>Select Employee</option>
                                </Form.Select>
                              </FloatingLabel>
                            </div>
                            <div className="col-md-6 form-group input-user">
                                <button type="button" className="btnval btn btn-primary font_size" onClick={this.handleFetchOldEmployee}>
                                    Fetch
                                </button>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-6 form-group input-user">
                                <FloatingLabel className="lableWidth" label="Employee Name *">
                                  <Form.Control className="edit_job_edit form__field" type="text"  required={true} name="Workforce"  onChange={this.handleDataChangeOther} value={this.state.Workforce} placeholder="Order #"/>
                              </FloatingLabel>
                            </div>
                            <div className="col-md-6 form-group input-user DateAlign">
                              <FloatingLabel className="lableWidth" label="Status *">
                                  <Form.Control className="edit_job_edit form__field" type="text"  required={true} name="Workforce"  onChange={this.handleDataChangeOther} value={this.state.Workforce} placeholder="Status"/>
                              </FloatingLabel>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-6 form-group input-user">
                                <FloatingLabel className="lableWidth" label="Branch *">
                                  <Form.Control className="edit_job_edit form__field" type="text"  required={true} name="Workforce"  onChange={this.handleDataChangeOther} value={this.state.Workforce} placeholder="Order Value"/>
                              </FloatingLabel>
                            </div>
                            <div className="col-md-6 form-group input-user">
                              <FloatingLabel className="lableWidth" label="Dept *">
                                  <Form.Control className="edit_job_edit form__field" type="text"  required={true} name="Workforce"  onChange={this.handleDataChangeOther} value={this.state.Workforce} placeholder="BG Value"/>
                              </FloatingLabel>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-6 form-group input-user">
                              <FloatingLabel className="lableWidth" label="Site *">
                                  <Form.Control className="edit_job_edit form__field" type="text"  required={true} name="Workforce"  onChange={this.handleDataChangeOther} value={this.state.Workforce} placeholder="BG Value"/>
                              </FloatingLabel>
                            </div>
                            <div className="col-md-6 form-group input-user">
                                <FloatingLabel className="lableWidth" label="Etc *">
                                  <Form.Control className="edit_job_edit form__field" type="text"  required={true} name="Workforce"  onChange={this.handleDataChangeOther} value={this.state.Workforce} placeholder="BG Value"/>
                              </FloatingLabel>
                            </div>
                          </div>
                          <div className='row mt-2'>
                            <div className="col-md-12 form-group input-user">
                            <Table bordered responsive className="">
                                <thead>
                                  <th className="taskWith alginCenter">OP AD<span className="required">*</span></th>
                                  <th className='alginCenter'>O365<span className="required">*</span></th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td></td>
                                    <td>
                                      <BootstrapSwitchButton
                                          // checked={item.Action === 1 ? true : false}
                                          onlabel='Yes'
                                          name="Action"
                                          offlabel='No'
                                          onstyle="success"
                                          offstyle="light"
                                          width={85}
                                          style="toggleClass"
                                        //   onChange={(checked: boolean) => {
                                        //     this.setState((state, props) => {
                                        //       var name = "Action";
                                        //       var saveDataAction = 0;
                                        //       if(checked === true){
                                        //         saveDataAction = 1;
                                        //       }
                                        //       state.JobTasksEngg[index][name] = saveDataAction;
                                        //       return {
                                        //         JobTasksEngg: state.JobTasksEngg,
                                        //       }
                                        //     })
                                        // }}
                                      />
                                    </td>
                                  </tr>
                                </tbody>  
                              </Table>
                            </div>                         
                          </div>
                         <div className="row mt-3">
                          <div className="col-md-4 form-group input-user">
                            
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <button type="submit" className="btnval btn btn-success font_size">
                                Suspend  
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user">
                            <button type="button" onClick={this.handleClose} className="btnval btn btn-danger font_size">
                                Cancel
                            </button>
                          </div>
                          <div className="col-md-3 form-group input-user">
                             
                          </div>
                        </div>
                      </form>
                      :""}
                    </div>
                  </div>
              </div>     
                                  
            </Offcanvas.Body>
        </Offcanvas>
      </div>
    )
  }
}





